/** @jsx jsx */
import { css } from '@emotion/core';
import helperUtils from '../utils/helper.util';
import baseStyles from './base.styles';

const columnWidth = width => css`
  width: ${width}px;
`;

const trWrapper = theme => css`
  word-break: break-all;
  word-wrap: break-all;
  white-space: pre-wrap;
  height: auto;
  ${baseStyles.offsetStyleRowForType(theme, 'even')}
`;

const paginationWrapper = theme => css``;

const tableWrapper = theme =>
  css`
    border-collapse: collapse;
    overflow-x: auto;
    table-layout: fixed;
    min-width: 100%;
    ${baseStyles.borderBottomLine(theme)}

    & div[data-test$="-cybsMenuButton"], div[data-test$="-cybsCombobox"] {
      position: static;
      div:nth-child(2) {
        z-index: 3;
      }
    }

    &:focus {
      outline: 1px dashed;
      ${theme?.classes?.skin?.outline?.element?.dark?.styles ?? 'outline-color: #222222'};
      outline-offset: -1px;
    }

    &.first-sticky {
      thead tr {
        td:first-child,
        th:first-child {
          z-index: 3 !important;
        }
      }
      tr {
        td:first-child,
        th:first-child {
          position: sticky;
          left: 0;
          z-index: 2;
          box-shadow:
            inset -2px 0 ${theme?.cybs?.base?.cybs?.mediumGray ?? '#d9d9d6'},
            inset 0 0 0 50vmin white;
        }

        &:nth-child(even) td:first-child,
        &:nth-child(even) th:first-child {
          box-shadow:
            inset -2px 0 ${theme?.cybs?.base?.cybs?.mediumGray ?? '#d9d9d6'},
            inset 0 0 0 50vmin ${theme?.cybs?.base?.cybs?.lightGray ?? '#f4f4f4'};
        }
      }
    }

    &.sticky {
      thead tr {
        td,
        th {
          background: white;
          border-bottom: 0;
          box-shadow: inset 0px -2px ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
          display: table-cell;
          margin-bottom: 2px;
          position: sticky;
          top: 0;
          z-index: 2;
        }
      }

      tr.filterRow {
        td, th {
          top: 3.575rem;
          background: ${theme?.cybs?.base?.cybs?.lightGray ?? '#f4f4f4'};
          box-shadow:
              0 -2px ${theme?.cybs?.base?.cybs?.lightGray ?? '#f4f4f4'},
              inset 0px -2px ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
          z-index: 2;
        }
      }
      & div[data-test$="-cybsMenuButton"], div[data-test$="-cybsCombobox"] {
        position: relative;
        div:nth-child(2) {
          z-index: 1;
        }
      }
    }

    &.sticky.first-sticky {
      thead tr {
        &.filterRow {
          td, th {
            &:first-child {
              box-shadow:
                inset 0px -2px ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'},
                inset -2px 0 ${theme?.cybs?.base?.cybs?.mediumGray ?? '#d9d9d6'},
                0 -1px ${theme?.cybs?.base?.cybs?.lightGray ?? '#f4f4f4'},
                inset 0 0 0 50vmin ${theme?.cybs?.base?.cybs?.lightGray ?? '#f4f4f4'};
            }
          }
        }
        td, th {
          &:first-child {
            box-shadow:
              inset 0px -2px ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'},
              inset -2px 0 ${theme?.cybs?.base?.cybs?.mediumGray ?? '#d9d9d6'},
              inset 0 0 0 50vmin white;
          }
        }
      }
    }

    tbody {
      /* "No results" warning icon */
      svg.vds-icon.vds-icon--high[ariaLabel='warning'] use {
        fill: ${theme?.cybs?.base?.vault?.orange ?? '#ff9800'};
      }
    }

    tr {
      vertical-align: middle;
      border-color: inherit;
      min-height: 3rem;

      &.pad-row {
        height: 3.5rem;
      }
    }

    .rowAction {
      text-align: center;
    }

    tr th,
    tr td {
      ${helperUtils.checkObjectForDataPath(
        theme,
        'classes.structure.padding.space.left.2'
      )
        ? theme.classes.structure.padding.space.left[2]
        : 'padding-left:1.0rem;label:structPadding;'};
      ${helperUtils.checkObjectForDataPath(
        theme,
        'classes.structure.padding.space.right.2'
      )
        ? theme.classes.structure.padding.space.right[2]
        : 'padding-right:1.0rem;label:structPadding;'};
      ${helperUtils.checkObjectForDataPath(
        theme,
        'classes.structure.padding.space.top.1'
      )
        ? theme.classes.structure.padding.space.top[1]
        : 'padding-top:0.5rem;label:structPadding;'};
      ${helperUtils.checkObjectForDataPath(
        theme,
        'classes.structure.padding.space.bottom.1'
      )
        ? theme.classes.structure.padding.space.bottom[1]
        : 'padding-bottom:0.5rem;label:structPadding;'};
      color: ${baseStyles.tableAltColor(theme)};
    }

    tr:first-child th {
      vertical-align: middle;
    }

    tr:not(:first-child) th,
    tr td {
      vertical-align: middle;
    }

    .gridRowHeader {
      vertical-align: middle;
      border-color: inherit;
      color: ${baseStyles.tableAltColor(theme)};

      th {
        border-bottom: 2px solid ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
        ;
      }
    }

    .filterRow {
      vertical-align: middle;
      border-color: inherit;
      color: ${baseStyles.tableAltColor(theme)};

      ${baseStyles.offsetStyleRowForType(theme, 'even')}

      th {
        font-weight: inherit !important;
        ${baseStyles.borderBottomLine(theme)}
      }
    }

    div,
    tr th,
    tr td {
      outline: none;
    }

    input {
      outline: none;
      border: 0;
    }

    input[type='text']::-ms-clear {
      display: none;
    }

    ${/*  IE STYLES */ ''}
    ${helperUtils.checkBrowser('ie')
      ? `
      th {
        text-align: left;
      }
    `
      : ''};
  `;

export default {
  columnWidth: width => columnWidth(width),
  tableWrapper,
  trWrapper,
  paginationWrapper
};
